import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

@Component({
  selector: 'app-codex-indicator-view',
  templateUrl: './codex-indicator-view.component.html',
  styleUrls: ['./codex-indicator-view.component.scss']
})
export class CodexIndicatorViewComponent implements OnInit {
  @ViewChild('carousel') carousel: any;

  @Input() currentReport!: any;
  @Input() codexesByCategory!: any;

  @Output() categoryChanged = new EventEmitter<any>();
  
  currentPage: number = 0;

  constructor() { }

  ngOnInit(): void {
  }

  isCenter(index: number): boolean {
    return index % this.currentReport.details.length === (this.currentPage + 1) % this.currentReport.details.length;
  }

  changeIndicator(event: any) {
    this.categoryChanged.emit(this.currentReport.details[event.page].category.uuid);
  }

  nextCarouselPage() {
    this.carousel.navForward();
  }

  prevCarouselPage() {
    this.carousel.navBackward();
  }

}
